import React from 'react';
import { Shield, Award, Users } from 'lucide-react';

const About = () => {
  return (
    <div className="bg-black text-white min-h-screen pt-32">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          <div className="relative">
            <img src="/assets/Voiture2.jpg" alt="Notre expertise" className="rounded-2xl shadow-2xl border border-gray-800" />
            <div className="absolute -bottom-6 -right-6 bg-orange-500 p-8 rounded-2xl hidden md:block">
              <p className="text-4xl font-bold">10+</p>
              <p className="text-sm font-semibold uppercase">Véhicules en Stock</p>
            </div>
          </div>
          
          <div>
            <h1 className="text-5xl font-bold mb-8 italic">"Top Car, la route <br/><span className="text-orange-500">commence ici"</span></h1>
            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              Agence TOP CAR est votre partenaire de confiance à Kinshasa pour l'achat et l'importation de véhicules. Nous sélectionnons rigoureusement chaque voiture pour garantir votre sécurité et votre confort.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
              <div className="flex items-center gap-4">
                <Shield className="text-orange-500" size={32} />
                <span className="font-bold">Qualité Garantie</span>
              </div>
              <div className="flex items-center gap-4">
                <Award className="text-orange-500" size={32} />
                <span className="font-bold">Service Premium</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
